import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem('token'));
    const [user, setUser] = useState(null);
    const [userToken, setUserToken] = useState('');
    const [role, setRole] = useState(localStorage.getItem('role') || '');  
   
    const login = (data) => {
        const token = data.token.split('|')[1];
        localStorage.setItem('token', token);
        localStorage.setItem('role', data.user.role_type);  
        setUser(data.user);
        setRole(data.user.role_type); 
        setIsAuthenticated(true);
        setUserToken(token);
    };

    const logout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('role');  
        setIsAuthenticated(false);
        setRole('');
    };

    const authAxios = axios.create();
    authAxios.interceptors.request.use((config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    });

    useEffect(() => {
    }, [isAuthenticated]);

    return (
        <AuthContext.Provider value={{ isAuthenticated, login, logout, authAxios, user, role }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
